var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NoticeToPassengersText container_w dis_bo",staticStyle:{"padding-top":"96px"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.collapseHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }